import React from "react";
import { Navigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import PageHeader from "@/components/PageHeader";
import { AccountsView } from "@/components/AccountsView";
import { ReportEmails } from "@/components/ReportEmails";

export default function Accounts() {
  const { user } = useAuth();
  if (user?.role !== "owner") return <Navigate to="/inbox" replace />;
  return (
    <div>
      <PageHeader eyebrow="Business" title="Accounts" subtitle="Every rupee in and out — customer payments, member fees, expenses, salaries and commissions" />
      <div className="p-4 sm:p-8"><ReportEmails /><AccountsView client={api} /></div>
    </div>
  );
}
